import router from "@/router";
import Vue from "vue";
import axios from "axios";
import CONSTANTS from "@/constants.js";
//Apply -> Apply changes in Active Product

//Save -> Save finals changes

//Update -> Async calls to save changes

const snapsheet = {
  namespaced: true,

  state: () => ({
    color_1: null,
    color_2: null,
    color_3: null,
    collectionsCardsData: [],
    decorationHasBeenEdited: false,
    editTitleActive: false,
    gender: "Men",
    // --Logos
    logos: [],
    defaultLogoId: null,
    spiritwearLogoId: null,
    uniformsLogoId: null,
    //--
    isEditModeActive: false,
    layoutId: "",
    pages: [],
    PER_PAGE: 3,
    products: [],
    productHasBeenEdited: false,
    title: "",
    repId: "",
    showPrices: true,
    status: "",
    snapsheetId: "",
    snapsheetColorsIds: [
      5, 6, 7, 8, 10, 13, 14, 15, 16, 18, 19, 20, 21, 22, 23, 25,
    ],
    snapsheetsTemplates: [],
    snapsheetCollections: [],
    teamName: "",
    templateId: "",
    isStaticTemplate: false,
  }),

  getters: {
    getSnapsheetStatus: (state) => state.status,

    isStaticTemplate: (state) => state.isStaticTemplate,

    getSnapsheetTemplateById: (state) => (templateId) => {
      return state.snapsheetsTemplates.filter(
        (template) => template.id == templateId
      )[0];
    },

    getSnapsheetTemplateId: (_, getters) => (templateId) => {
      return getters.getSnapsheetTemplateById(templateId).snapsheet_id;
    },

    getSnapsheetTemplateColor: (_, getters) => (templateId) => {
      return getters.getSnapsheetTemplateById(templateId).color_id;
    },

    productIsDuplicated: (state) => (productId) => {
      return state.products.some(
        (savedProduct) => savedProduct.id == productId
      );
    },

    productEditableGridPrice: () => (product) => {
      const selfData = {
        alias: product.alias,
        gender: product.gender ? product.gender : product.genders[0],
        price: product.price,
        sizes: product.sizes,
        style_id: product.style_id,
      };

      if (product.related) {
        const otherGenders = product.related
          ?.filter((genderData) => genderData.style_id != product.style_id)
          ?.map((genderData) => ({
            alias: genderData.alias,
            gender: genderData.gender
              ? genderData.gender
              : genderData.genders[0], //A veces viene en un array de una sola posicion, otras veces como string 👀
            price: Number(genderData.price).toFixed(2),
            sizes: genderData.sizes,
            style_id: genderData.style_id,
          }));

        otherGenders?.unshift(selfData);
        return otherGenders;
      } else {
        return [selfData];
      }
    },

    temporalProductIsNew: (state, _getters, rootState) => {
      return (
        Object.keys(rootState.project.temporalProduct).length > 0 &&
        rootState.project.temporalProduct.id &&
        !state.products.some(
          (pr) => pr.id == rootState.project.temporalProduct.id
        )
      );
    },

    isTemporalProductEmpty: (_state, _getters, rootState) => {
      return !rootState.project.temporalProduct.id;
    },

    getProductByOrder: (state) => (order) => {
      return Object.assign(
        state.products.filter((pr) => pr.order === order)[0]
      );
    },

    getLastSnapsheetItem: (state) => {
      return state.products[state.products.length - 1];
    },

    lockerCode: (state) => {
      return state.lockerCode;
    },

    showAdditionalOptionInSidebar: (
      state,
      _getters,
      _rootState,
      rootGetters
    ) => {
      return state.products.some((product) =>
        rootGetters["project/productIsUniform"](product)
      );
    },
  },

  actions: {
    async initSnapsheet({ rootGetters, dispatch }, skipCreate = false) {
      try {
        //Get the collections data (it goes in the project sidebar)
        await dispatch("getSnapsheetCollectionsBasicData");

        //If we are in create mode, create a new snapsheet and set the id
        if (rootGetters["project/isCreateMode"] && !skipCreate) {
          //Check  if there is a snapsheet template id in the query
          const templateId = router.currentRoute.query.snapsheet_template;
          console.log("templateId", templateId);
          console.log("router.currentRoute.query", router.currentRoute.query);
          if (templateId) {
            await dispatch("createSnapsheetFromTemplate", templateId);
          } else {
            //Create from scratch
            await dispatch("createSnapsheet");
          }
        }

        //Get the snapsheet
        await dispatch("getSnapsheet");

        //Calculate all pages
        // await dispatch("calculatePages");
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "Error init snapsheet",
            type: "error",
          },
          { root: true }
        );
        console.log(error);
      }
    },

    resetSnapsheet({ commit }) {
      commit("SET_SNAPSHEET", {
        color_1: null,
        color_2: null,
        color_3: null,
        collectionsCardsData: [],
        decorationHasBeenEdited: false,
        editTitleActive: false,
        gender: "Men",
        // --Logos
        logos: [],
        spiritwearLogoId: null,
        uniformsLogoId: null,
        //--
        isEditModeActive: false,
        layoutId: "",
        lockerCode: "",
        pages: [],
        PER_PAGE: 3,
        products: [],
        productHasBeenEdited: false,
        title: "",
        repId: "",
        showPrices: true,
        status: "",
        snapsheetId: "",
        snapsheetColorsIds: [
          5, 6, 7, 8, 10, 13, 14, 15, 16, 18, 19, 20, 21, 22, 23, 25,
        ],
        snapsheetsTemplates: [],
        snapsheetCollections: [],
        templateId: "",
        isStaticTemplate: false,
      });
    },

    async createSnapsheet({ rootState, commit, dispatch }) {
      try {
        const options = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        };
        const response = await axios.post(
          rootState.settings.endpoint + `api/v2/snapsheets/create`,
          null,
          options
        );
        const newSnapsheetId = response.data.snapsheet_id;
        commit("setSnapsheetId", newSnapsheetId);
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "Error creating snapsheet",
            type: "error",
          },
          { root: true }
        );
        console.log(error);
      }
    },

    async createSnapsheetFromTemplate(
      { rootState, getters, dispatch, commit },
      templateId
    ) {
      try {
        //Start from templates
        const url =
          rootState.settings.endpoint +
          `api/snapsheets/clone-from-template/${templateId}`;
        const params = {};

        //If the template is for colors, set the featured color
        const selectedTemplate = getters.getSnapsheetTemplateById(templateId);

        //Set the color of the template as the Featured color (color_1)
        if (selectedTemplate.type.toLowerCase() === "color") {
          params["color_1"] = selectedTemplate.featured_color;
        }

        const { data } = await axios.post(url, params, {
          headers: { Authorization: "Bearer " + rootState.auth.apiToken },
        });

        //Set the new snapsheet id
        commit("setSnapsheetId", data.id);
        //Set the color of the template as the Featured color (color_1)
        if (selectedTemplate.type.toLowerCase() === "color") {
          await dispatch("updateSnapsheetColor", {
            colorId: selectedTemplate.featured_color,
          });
        }
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "Error creating snapsheet",
            type: "error",
          },
          { root: true }
        );
        console.log(error);
      }
    },

    async getSnapsheetCollectionsBasicData({ rootState, commit }) {
      const url = rootState.settings.endpoint + `api/v2/snapsheets/collections`;
      const response = await axios.get(url);

      const collectionsData = Object.keys(response.data).map(
        (key) => response.data[key]
      );

      commit("SET_COLLECTIONS_CARDS_DATA", collectionsData);
    },

    async addSnapsheetCollection(
      { state, rootState, dispatch },
      collectionSlug
    ) {
      dispatch("triggerStartLoading", null, { root: true });
      const snapsheetId = state.snapsheetId;
      const params = { collection: collectionSlug };
      const url = `${rootState.settings.endpoint}api/v2/snapsheets/${snapsheetId}/collections`;
      try {
        const { data } = await axios.put(url, params, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        });
        //Check if the last product is on the third space in the last page. In that case, we need to set the next page as actual page
        const prevLastProduct = state.products
          .filter((p) => p?.id)
          ?.slice(-1)[0];
        const prevLastPageNumber = state.pages.length;
        const prevLastPage = state.pages[state.pages.length - 1];

        //Check if the prevuois last product was in the last position of the last page. If so, we need to go to the next page
        const mustSetNextPage =
          prevLastPage?.products?.findIndex(
            (p) => p?.id === prevLastProduct?.id
          ) === 2;

        //Update the pages and SS data
        await dispatch("setSnapsheet", data);

        //First check if the last prev product is still in the products state, because it could have been deleted on a toggle action
        if (
          state.products.some((p) => p?.id === prevLastProduct?.id) &&
          prevLastProduct
        ) {
          //Set the first page of the new collection as the actual page
          if (mustSetNextPage) {
            dispatch("project/setPage", prevLastPageNumber + 1, { root: true });
          } else {
            //Check if the updated prevLastPageNumber has products
            if (
              state.pages[prevLastPageNumber - 1]?.products?.some(
                (pr) => pr?.id
              )
            ) {
              // set the prev last page as the actual page
              dispatch("project/setPage", prevLastPageNumber, { root: true });
            } else {
              dispatch("project/setPage", state.pages.length, { root: true });
            }
          }
        } else {
          //If the product doesn't exist anymore, set the first page as the actual page
          dispatch("project/setPage", 1, { root: true });
        }
      } catch (error) {
        console.log(error);
        dispatch(
          "showToast",
          {
            txt: "Error adding collection",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async getSnapsheet({ rootState, state, commit, dispatch }) {
      //Get the snapsheet id from the most recent created or from the url param
      const snapsheetId =
        state.snapsheetId || router.currentRoute.params.project_id;
      commit("setSnapsheetId", snapsheetId);
      const url = rootState.settings.endpoint + `api/snapsheets/${snapsheetId}`;
      const params = { dealer_code: rootState.dealer.rhino_code };

      try {
        const { data } = await axios.get(url, { params });

        //Set snapsheet data
        await dispatch("setSnapsheet", data);
        //Push the rep to the reps lists in dealer module, if the rep list is empty
        if (!rootState.dealer?.reps?.length)
          dispatch("dealer/setAllReps", [data.rep], { root: true });
      } catch (error) {
        console.log(error);

        router.push("/404");
        dispatch(
          "showToast",
          {
            txt: "Error getting snapsheet",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async setSnapsheet({ rootGetters, dispatch, commit }, snapsheetData) {
      console.log("setSnapsheet");
      const normalizedLogos = snapsheetData.logos?.map((logo) => {
        return logo && rootGetters["uploadLogos/normalizeLogoData"](logo);
      });
      const defaultLogoId = snapsheetData.default_logo_id;

      await dispatch("project/setProjectLogos", normalizedLogos, {
        root: true,
      });
      await dispatch("project/setDefaultLogo", defaultLogoId, {
        root: true,
      });

      snapsheetData.logos = normalizedLogos;
      commit("SET_SNAPSHEET", snapsheetData);

      await dispatch("setSnapsheetProducts", snapsheetData.products);

      if (normalizedLogos?.length) {
        const mainLogo = rootGetters["project/getLogoById"](defaultLogoId);
        commit("project/SET_UNIFORM_CUSTOM_GRAPHIC", mainLogo, { root: true });
        commit("project/SET_SPIRITWEAR_CUSTOM_GRAPHIC", mainLogo, {
          root: true,
        });
      }

      //Update Uniform colors
      await dispatch(
        "project/setDefaultUniformAndSpiritwearDecorationColors",
        null,
        { root: true }
      );
      await dispatch("calculatePages");
    },

    async setSnapsheetProducts({ dispatch, commit }, products) {
      const normalizedProducts = [];

      for (const pr of products) {
        const normalizedProduct = await dispatch(
          "normalizeSnapsheetProduct",
          pr
        );
        normalizedProducts.push(normalizedProduct);
      }

      console.log({ normalizedProducts });
      normalizedProducts.forEach((pr) => {
        commit("ADD_PRODUCT", { product: pr, order: pr.order - 1 });
      });
    },

    async normalizeSnapsheetProduct(_, pr) {
      console.log("pr pre: ", pr);
      return {
        ...pr.product,
        ...pr,
        dealerPrice: pr.dealer_price || pr.dealerPrice,
        design: pr.variant_id
          ? pr.product?.variants?.filter(
              (variant) => variant.color_id == pr.variant_id
            )?.[0]
          : pr.product?.variants?.[0],
        order: pr.order,
        price: Number(pr.price).toFixed(2),
        customProductPrice: Number(pr.customProductPrice || pr.custom_price),
        related: pr.related || pr.product?.related,
        sizes: pr?.sizes || pr.product?.sizes,
        style_id: pr.style_id || pr.product?.style_id,
        styleId: pr.styleId || pr.product?.styleId,
        wrapperId: pr.wrapperId || pr.product?.wrapperId || pr?.id || pr.product?.id,

        //-- OLD LOGO PROPERTY
        logoId: pr.logo?.id, //Main logo Id
        //The modified original logo with its own properties
        logo: {
          id: pr.logo?.id,
          content: pr.logo_url || null,
          position:
            pr.logo_settings?.position ||
            CONSTANTS.DEFAULT_SCREEN_LOGO_PROPERTIES.position,
          zoom:
            pr.logo_settings?.zoom ||
            CONSTANTS.DEFAULT_SCREEN_LOGO_PROPERTIES.zoom,
        },
        //--

        activeLayoutId: pr.active_layout || pr.product?.layouts?.[0]?.id,
        variant:
          pr.variant?.trim() || pr.product?.variants?.[0].color_name.trim(),
        wasAddedToLocker: false,

        //new Decorations property
        decorations: pr.decorations || {
          front: {
            name: { value: "", fill: "", outline: "" },
            number: { value: "", fill: "", outline: "" },
            logo: pr.decorations?.front?.logo || {
              id: pr.logo?.id,
              content: pr.logo_url || null,
              position:
                pr.logo_settings?.position ||
                CONSTANTS.DEFAULT_SCREEN_LOGO_PROPERTIES.position,
              zoom:
                pr.logo_settings?.zoom ||
                CONSTANTS.DEFAULT_SCREEN_LOGO_PROPERTIES.zoom,
              visible: true,
            },
          },
          back: {
            name: { value: "" },
            number: { value: "" },
            logo: {},
          },
          side: {
            name: { value: "" },
            number: { value: "" },
            logo: {},
          },
        },

        //Is or not sublimable prop
        isSublimable: !!pr.is_sublimable,
        //Is uniform
        isUniform: pr.category === "Jerseys",

        //Custom Configs
        threekitConfigId: pr.threekit_config_id,
        threekitSavedPreview: pr.threekit_saved_preview,
        threekitDecorations: pr.threekit_decorations,
      };
    },

    // async setProduct({ dispatch, commit }, pr) {
    //   const product = await dispatch("normalizeSnapsheetProduct", pr);
    //   commit("ADD_PRODUCT", { product: product, order: product.order - 1 });
    // },

    async getSnapsheetTemplates({ state, rootState, dispatch, commit }) {
      if (state.snapsheetsTemplates.length) return false;

      try {
        const url = rootState.settings.endpoint + "api/snapsheets/templates";
        const options = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        const { data } = await axios.get(url, options);

        commit("SET_SNAPSHEETS_TEMPLATES", data);
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "Error",
            type: "error",
          },
          { root: true }
        );
      }
    },

    async updateSnapsheetStatus({ rootState, state, commit }, status) {
      try {
        const params = {
          id: state.snapsheetId,
          _method: "put",
          status,
        };

        const url =
          rootState.settings.endpoint + "api/snapsheets/" + state.snapsheetId;

        let config = {
          headers: {
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        };

        await axios.put(url, params, config);

        commit("SET_SNAPSHEET_STATUS", status);
      } catch (error) {
        throw new Error(error);
      }
    },

    async updateShowPrices({ rootState, state, commit }, showPrices) {
      try {
        const params = {
          id: state.snapsheetId,
          _method: "put",
          show_prices: showPrices,
        };

        const url =
          rootState.settings.endpoint + "api/snapsheets/" + state.snapsheetId;

        let config = {
          headers: {
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        };

        await axios.put(url, params, config);

        commit("SET_SNAPSHEET_SHOW_PRICES", showPrices);
      } catch (error) {
        throw new Error(error);
      }
    },

    //---Products
    updateProductsThreekitData({ state, dispatch }) {
      //Filter duplicated products to avoid unnecessary calls
      const uniqProducts = [];
      state.products?.forEach((pr) => {
        if (!uniqProducts.some((uniqPr) => uniqPr?.id === pr?.id)) {
          uniqProducts.push(pr);
        }
      });

      uniqProducts?.map((pr) => {
        return (
          (pr?.style_id || pr?.alias) &&
          dispatch(
            "threekit/initProductCache",
            {
              styleName: pr.style_id,
              designName: pr.threekit_designs?.[0]?.design_name,
            },
            { root: true }
          )
        );
      });
    },

    async setProduct({ commit, dispatch }, { product, wrapperId }) {
      const normalizedProduct = await dispatch(
        "normalizeSnapsheetProduct",
        product
      );

      const finalProduct = {
        order: product.order - 1,
        product: {
          ...normalizedProduct,
          price: normalizedProduct.price
            ? Number(normalizedProduct.price).toFixed(2)
            : Number(normalizedProduct.msrp).toFixed(2),
          wrapperId: wrapperId ? wrapperId : product.wrapperId || product.id, //This happens when the user selects a new product. We need to set the WrapperId that came from the backend response
        },
      };

      commit("ADD_PRODUCT", finalProduct);
      console.log({ product, wrapperId, finalProduct });
      dispatch("calculatePages");
    },

    async saveNewSnapsheetProduct({ rootState, state, dispatch }) {
      const snapsheetId = state.snapsheetId;
      let url = rootState.settings.endpoint + `api/snapsheetproducts`;

      const temporalProduct = rootState.project.temporalProduct;
      const { id, price, order, related, decorations } = temporalProduct;
      const relatedPrices =
        related &&
        related.map((genderProduct) => ({
          style_id: genderProduct.style_id,
          price: genderProduct.price,
        }));

      let params = {
        snapsheet_id: snapsheetId,
        product_id: id,
        price: Number(price),
        order,
        decorations,
      };

      let settings = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + rootState.auth.apiToken,
        },
      };
      //If the product has related prices
      if (relatedPrices) {
        params["related_prices"] = relatedPrices;
      }

      try {
        //Create or Swap
        await axios.post(url, params, settings);

        await dispatch("getSnapsheet");

        //Remove the temporal product
        dispatch("project/removeTemporalProduct", null, { root: true });
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "Error trying to save the product",
            type: "error",
          },
          { root: true }
        );
        console.log(error);
      }
    },

    async updateProduct({ rootState, state, dispatch }, product) {
      const snapsheetId = state.snapsheetId;
      const { id, price, order, related, wrapperId } = product;
      const relatedPrices =
        related &&
        related.map((genderProduct) => ({
          style_id: genderProduct.style_id,
          price: genderProduct.price,
        }));
      let url =
        rootState.settings.endpoint + `api/snapsheetproducts/${wrapperId}`;

      let params = {
        snapsheet_id: snapsheetId,
        product_id: id,
        price: Number(price),
        order,
        variant: product.variant,
        decorations: product.decorations,
        layout_id: product.activeLayoutId, //todo -> this is not being updated, check with digi
      };

      let settings = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + rootState.auth.apiToken,
        },
      };
      //If the product has related prices
      if (relatedPrices) {
        params["related_prices"] = relatedPrices;
      }
      try {
        const { data } = await axios.put(url, params, settings);

        await dispatch("setProduct", { wrapperId: data.id, product: product });
      } catch (error) {
        {
          dispatch(
            "showToast",
            {
              txt: "Error trying to update the product",
              type: "error",
            },
            { root: true }
          );
        }
      }
    },

    async updateProductCustomChanges(
      { rootState },
      { wrapperId, threekitConfigId, threekitSavedPreview }
    ) {
      try {
        let url =
          rootState.settings.endpoint + `api/snapsheetproducts/${wrapperId}`;

        let threekitDecorations = rootState.threekit.decorations3DList.map(
          (decoration) => {
            //Do not save the thumbnails
            return {
              ...decoration,
              thumbnail: null,
            };
          }
        );

        let params = {
          threekit_config_id: threekitConfigId,
          threekit_saved_preview: threekitSavedPreview,
          threekit_decorations: threekitDecorations,
        };

        let settings = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        };

        const { data } = await axios.put(url, params, settings);
        return data;
      } catch (error) {
        console.log(error);
      }
    },

    async updateProductOrder({ rootState, state, dispatch }, product) {
      const snapsheetId = state.snapsheetId;
      const { id, order, wrapperId } = product;

      const url =
        rootState.settings.endpoint + `api/snapsheetproducts/${wrapperId}`;

      let params = {
        snapsheet_id: snapsheetId,
        product_id: id,
        order,
      };

      let settings = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + rootState.auth.apiToken,
        },
      };

      try {
        await axios.put(url, params, settings);
      } catch (error) {
        {
          dispatch(
            "showToast",
            {
              txt: "Error trying to update the product",
              type: "error",
            },
            { root: true }
          );
        }
      }
    },

    async updateProductPrice(
      { rootState, dispatch },
      { newPrice, styleId, isRelated, product }
    ) {
      const productWithEditedPrices = { ...product };
      const relatedPrices = [...product.related];

      //If the price to be edited is a related price
      if (isRelated) {
        productWithEditedPrices.related = relatedPrices.map(
          (relatedProduct) => {
            if (
              relatedProduct.style_id?.toLowerCase() === styleId?.toLowerCase()
            ) {
              relatedProduct.customProductPrice = newPrice;
            }

            return relatedProduct;
          }
        );
      } else {
        productWithEditedPrices.customProductPrice = newPrice;
      }

      let url =
        rootState.settings.endpoint +
        `api/snapsheetproducts/${product.wrapperId}`;
      let params = {
        custom_price: Number(productWithEditedPrices.customProductPrice),
        style_id: product.style_id,
      };

      //If the product has related prices
      if (relatedPrices) {
        params["related_prices"] = relatedPrices;
      }

      let settings = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + rootState.auth.apiToken,
        },
      };

      try {
        const { data } = await axios.put(url, params, settings);

        dispatch("setProduct", {
          wrapperId: data.id,
          product: productWithEditedPrices,
        });
      } catch (error) {
        throw new Error(error);
        // throw new Error('Error trying to update product price')
      }
    },

    removeProduct({ state, dispatch, commit }, orderId) {
      const productsWithOrderdsUpdated = state.products.map((product) => {
        //update the order the products
        if (product.order > orderId) {
          product.order--;
        }
        return product;
      });

      commit("SET_PRODUCTS", productsWithOrderdsUpdated);
      dispatch("calculatePages");
    },

    async deleteProduct({ rootState, state, dispatch }, orderId) {
      dispatch("triggerStartLoading", null, { root: true });
      //axios delete
      const snapsheetId = state.snapsheetId;
      const url =
        rootState.settings.endpoint +
        `api/snapsheets/snapsheet/${snapsheetId}/action/delete-product`;
      let settings = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + rootState.auth.apiToken,
        },
      };
      let params = {
        order: orderId,
      };

      try {
        await axios.post(url, params, settings);
        await dispatch("removeProduct", orderId);
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "Error trying to delete the product",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async swapProductOrders({ state, commit, dispatch }, { order, action }) {
      // const url = rootState.settings.endpoint + `api/snapsheetproducts/swap-orders`
      dispatch("project/triggerLoading", null, { root: true });
      dispatch("project/showSaveIndicator", null, { root: true });
      try {
        const order1 = order;
        const order2 = action === "up" ? order - 1 : order + 1;

        const product_1 = {
          ...state.products[order1 - 1],
        };
        const product_2 = {
          ...state.products[order2 - 1],
        };
        product_1.order = order2;
        product_2.order = order1;

        //Update the order
        await dispatch("updateProductOrder", product_1);
        await dispatch("updateProductOrder", product_2);

        commit("SWAP_PRODUCTS_ORDERS", { order1, order2 });
        dispatch("calculatePages");
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "Error updating snapsheet settings",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("project/endLoading", null, { root: true });
      }
    },

    async updateSnapsheetSettings(
      { rootState, state, dispatch, commit },
      { dbKey, field, value }
    ) {
      const snapsheetId = state.snapsheetId;
      const url = rootState.settings.endpoint + `api/snapsheets/${snapsheetId}`;
      let settings = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + rootState.auth.apiToken,
        },
      };

      let params = {
        [dbKey]: value,
      };

      try {
        await axios.put(url, params, settings);

        commit("SET_SNAPSHEET_SETTINGS", { [field]: value });
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "Error updating snapsheet settings",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async updateProductVariantColor(
      { rootState, rootGetters, dispatch },
      { wrapperId, order, selectedColorName }
    ) {
      try {
        const url =
          rootState.settings.endpoint + `api/snapsheetproducts/` + wrapperId;

        let settings = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        };

        let params = {
          variant: selectedColorName,
        };

        await dispatch("saveProductVariantColor", { order, selectedColorName });

        //Call to the API to apply this change only in dealer mode or when the project is not locked
        !rootGetters["actionsPermissions/isProjectLocked"] &&
          (await axios.put(url, params, settings));
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "Error trying to update the product color",
            type: "error",
          },
          { root: true }
        );
        console.log(error);
      } finally {
        // dispatch('triggerEndLoading', null, { root: true })
      }
    },

    async saveProductVariantColor(
      { getters, commit, dispatch },
      { order, selectedColorName }
    ) {
      return new Promise((resolve, reject) => {
        const product = getters.getProductByOrder(order);
        product.variant = selectedColorName.trim();
        product.design = selectedColorName
          ? product.variants.filter(
              (variant) => variant.color_name.trim() == selectedColorName.trim()
            )[0]
          : product.variants[0];

        commit("ADD_PRODUCT", { order: order - 1, product });
        dispatch("changeEditMode", false)
          .then(() => resolve())
          .catch((e) => reject(e));
      });
    },

    async updateSnapsheetColor(
      { rootState, state, dispatch, commit },
      { colorId, colorKey = "color_1" }
    ) {
      try {
        const wrapperIds = state.products.map((pr) => pr.id);
        // dispatch('triggerStartLoading', null, { root: true })

        // Tomorrowland: check if we still need/will use this kind of logic to 'lock' projects
        // if (!rootGetters["actionsPermissions/isProjectLocked"]) {
        const snapsheetId = state.snapsheetId;
        const url =
          rootState.settings.endpoint +
          `api/snapsheets/action/featured-color/${snapsheetId}`;

        let settings = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        };

        let params = {
          color_key: colorKey,
          color_id: colorId,
          wrapper_ids: wrapperIds,
        };

        await axios.put(url, params, settings);
        // await dispatch("initSnapsheet");
        // }

        if (colorKey === "color_1") {
          await dispatch("saveFeaturedColor", colorId);
        }

        commit("SET_COLOR", { colorId, colorKey });
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "Error trying to update featured color",
            type: "error",
          },
          { root: true }
        );
        console.log(error);
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    saveFeaturedColor(
      { rootState, state, getters, dispatch, commit },
      selectedColorId
    ) {
      // Save the products's color in order
      state.products.reduce(async (previousPromise, actProduct) => {
        try {
          await previousPromise;

          return new Promise((resolve, reject) => {
            const product = getters.getProductByOrder(actProduct.order);

            //This space is empty
            if (!product.variants) {
              resolve();
            }

            const productDesignsMatchedByColorFamily = product.variants?.filter(
              (variant) => variant.color_family == selectedColorId
            );
            const finalDesignSelected =
              productDesignsMatchedByColorFamily.length
                ? productDesignsMatchedByColorFamily[0]
                : product.variants[0];
            product.design = finalDesignSelected;
            product.variant = finalDesignSelected.color_name.trim();

            commit("ADD_PRODUCT", { order: actProduct.order - 1, product });
            dispatch("changeEditMode", false)
              .then(() => resolve())
              .catch((e) => reject(e));
          });
        } catch (e) {
          // console.log(e);
          Promise.reject();
          throw new Error("error saving featured color");
        }
      }, Promise.resolve());

      //Edit the temporal product if there is one (The product added manually and is waiting to be saved or canceled)
      if (!getters.isTemporalProductEmpty) {
        console.log("ere");
        const temporalProduct = rootState.project.temporalProduct;
        const productDesignsMatchedByColorFamily =
          temporalProduct.variants?.filter(
            (variant) => variant.color_family == selectedColorId
          );
        const finalDesignSelected = productDesignsMatchedByColorFamily.length
          ? productDesignsMatchedByColorFamily[0]
          : temporalProduct.variants[0];
        temporalProduct.design = finalDesignSelected;
        temporalProduct.variant = finalDesignSelected.color_name.trim();
        dispatch(
          "project/setTemporalProduct",
          { product: temporalProduct, order: temporalProduct.order },
          { root: true }
        );
      }
    },

    async updateSnapsheetGender({ rootState, state, dispatch }, payload) {
      dispatch("triggerStartLoading", null, { root: true });
      //axios post
      const snapsheetId = state.snapsheetId;
      const url =
        rootState.settings.endpoint +
        `api/snapsheets/action/change-gender/${snapsheetId}`;

      let settings = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + rootState.auth.apiToken,
        },
      };
      let params = {
        gender: payload.replace("'s", ""),
      };

      try {
        const skipCreate = true;
        await axios.put(url, params, settings);
        await dispatch("initSnapsheet", skipCreate);
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "Error trying to update the snapsheet selected gender",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    //--- Logos

    async uploadSnapsheetLogo({ dispatch }) {
      try {
        //Reset the apply mode
        dispatch("uploadLogos/setApplyMode", "project", { root: true });
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "Error trying to update logo",
            type: "error",
          },
          { root: true }
        );
      }
    },

    async updateSnapsheetLogo({ dispatch }, logo) {
      try {
        await dispatch("editSnapsheetLogo", logo);
        //Reset the apply mode
        dispatch("uploadLogos/setApplyMode", "project", { root: true });
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "Error trying to update logo",
            type: "error",
          },
          { root: true }
        );
      }
    },

    editSnapsheetLogo({ dispatch, commit }, logo) {
      commit("EDIT_SNAPSHEET_LOGO", logo);
      dispatch("updateDecorations", {
        mode: "update logo",
        logo,
      });
    },

    removeSnapsheetLogo({ state, commit }, logoId) {
      const logoIndex = state.logos.findIndex((logo) => logo.id == logoId);
      commit("REMOVE_SNAPSHEET_LOGO", logoIndex);
    },

    saveDecorationsData(
      { state, commit },
      { productsIds, sideKey, decorationKey, decorationData, visible = true }
    ) {
      [...state.products].map((product) => {
        if (productsIds?.includes(product.wrapperId)) {
          //update the decoration
          product.decorations[sideKey][decorationKey] = {
            ...decorationData,
            visible,
          };
          commit("ADD_PRODUCT", { order: product.order - 1, product });
        }
      });
    },
    //--- End Logos

    //Active Product actions

    applyActiveProductPrices(
      { rootState, dispatch, commit, getters },
      { value, styleId }
    ) {
      //The price belongs to the main product
      if (rootState.project.temporalProduct.style_id == styleId) {
        commit("applyMainProductPrice", value);
      } else {
        //Find the index of the price that is being edited
        const index = rootState.project.temporalProduct.related.findIndex(
          (genderProd) => genderProd.style_id == styleId
        );
        commit("applyRelatedProductPrice", { index, value });
      }

      //Let clear that the product has been edited, only when the product that is being edited isn't new
      !getters.temporalProductIsNew &&
        dispatch("changeProductHasBeenEdited", true);
    },

    changeEditMode({ commit, dispatch }, bool) {
      commit("setEditMode", bool);

      //To disable scroll in mobiles
      if (window.innerWidth <= 768 && bool === true) {
        document.body.style.overflow = "hidden";
      }

      //Clear the Active Product
      if (bool === false) {
        // commit('setEmptyTemporalProduct')
        dispatch("changeProductHasBeenEdited", false);

        //To able scroll in mobiles

        document.body.style.overflow = "initial";
      }
    },

    changeProductHasBeenEdited({ commit }, bool) {
      commit("setProductHasBeenEdited", bool);
    },

    changeDecorationHasBeenEdited({ commit }, bool) {
      commit("setDecorationHasBeenEdited", bool);
      commit("setEditMode", !bool);
    },

    toggleEditTitleActive({ commit }) {
      commit("toggleEditTitleActive");
    },

    calculatePages({ rootState, state, dispatch, commit }) {
      //Find the max order
      const maxOrder = state.products.length
        ? Math.max(...state.products.map((p) => p?.order)?.filter(order => !!order))
        : 1;

      const arrWithSpaces = [...Array(maxOrder)].map((_item, i) => ({
        order: i + 1,
      }));
      //Set the previous products in order
      state.products.forEach((pr) => {
        arrWithSpaces[Number(pr.order) - 1] = pr;
      });

      //If Dealer mode is active, add an extra space by adding a new empty space
      if (rootState.auth.dealerMode) {
        const isThereAnyEmptySpace = arrWithSpaces.some(
          (space) => !space?.alias
        );
        // const isPlaceholderProductTheUniqProduct =
        //   state.products.filter((pr) => pr.id)?.length === 1 &&
        //   state.products[0]?.alias ===
        //     CONSTANTS.SNAPSHEET_PLACEHOLDER_PRODUCT_ALIAS &&
        //   rootGetters["project/isCreateMode"];
        // if (!isThereAnyEmptySpace && !isPlaceholderProductTheUniqProduct)
        if (!isThereAnyEmptySpace) {
          arrWithSpaces.push({});
        }
      } else {
        //Eliminate the last empty space in Coach mode
        const lastSpace =
          arrWithSpaces[
            arrWithSpaces.length > 0 ? arrWithSpaces.length - 1 : 0
          ];
        if (!lastSpace?.alias) {
          arrWithSpaces.pop();
        }
      }

      //Set an order Id for each space
      const spacesWithOrder = arrWithSpaces.map((space, i) => ({
        ...space,
        order: space.order ? space.order : i + 1,
      }));

      //Create the pages
      const arrOfPages = spacesWithOrder
        .map((_item, index) => {
          return index % state.PER_PAGE === 0
            ? {
                products: spacesWithOrder.slice(index, index + state.PER_PAGE),
                type: "snapsheet",
              }
            : null;
        })
        .filter(function (item) {
          return item;
        });

      //Set products and set pages

      commit("setPages", arrOfPages);
      console.log({ arrOfPages });
      commit("SET_PRODUCTS", arrOfPages.map((page) => page.products).flat());

      //Set as current page, the actual page or the first page
      //Ex: You are in page 5. Eliminate one collection. Now the page 5 is empty, so set the page 1 as the current page

      const actualPage = state.pages[rootState.project.actualPage - 1];
      if (!actualPage?.products?.length) {
        dispatch("project/setPage", 1, { root: true });
      }

      //Update PLP
      dispatch("updateProductsThreekitData");
    },
  },

  mutations: {
    setSnapsheetId: (state, id) => (state.snapsheetId = id),

    SET_SNAPSHEET: (state, snapsheetData) => {
      state.color_1 = snapsheetData.color_1 || state.color_1; //whitZe color
      state.color_2 = snapsheetData.color_2 || state.color_2; //whitZe color
      state.color_3 = snapsheetData.color_3 || state.color_3; //whitZe color
      state.gender = snapsheetData.gender;
      state.logos = snapsheetData.logos;
      state.defaultLogoId = snapsheetData.default_logo_id || null;
      state.layoutId = snapsheetData.layout;
      state.lockerCode = snapsheetData.locker_code;
      state.title = snapsheetData.title;
      state.products = snapsheetData.products.map((pr) => ({
        ...pr.product,
        dealerPrice: pr.dealer_price,
        design: pr.variant_id
          ? pr.product?.variants?.filter(
              (variant) => variant.color_id == pr.variant_id
            )?.[0]
          : pr.product?.variants?.[0],
        order: pr.order,
        sizes: pr.product?.sizes,
        price: Number(pr.price).toFixed(2),
        related: pr.related,
        wrapperId: pr.id,

        //-- OLD LOGO PROPERTY
        logoId: pr.logo?.id, //Main logo Id
        //The modified original logo with its own properties
        logo: {
          id: pr.logo?.id,
          content: pr.logo_url || null,
          position:
            pr.logo_settings?.position ||
            CONSTANTS.DEFAULT_SCREEN_LOGO_PROPERTIES.position,
          zoom:
            pr.logo_settings?.zoom ||
            CONSTANTS.DEFAULT_SCREEN_LOGO_PROPERTIES.zoom,
        },
        //--

        activeLayoutId: pr.active_layout || pr.product?.layouts?.[0]?.id,
        variant:
          pr.variant?.trim() || pr.product?.variants?.[0].color_name.trim(),
        wasAddedToLocker: false,

        //new Decorations property
        decorations: pr.decorations || {
          front: {
            name: { value: "", fill: "", outline: "" },
            number: { value: "", fill: "", outline: "" },
            logo: pr.decorations?.front?.logo || {
              id: pr.logo?.id,
              content: pr.logo_url || null,
              position:
                pr.logo_settings?.position ||
                CONSTANTS.DEFAULT_SCREEN_LOGO_PROPERTIES.position,
              zoom:
                pr.logo_settings?.zoom ||
                CONSTANTS.DEFAULT_SCREEN_LOGO_PROPERTIES.zoom,
              visible: true,
            },
          },
          back: {
            name: { value: "" },
            number: { value: "" },
            logo: {},
          },
          side: {
            name: { value: "" },
            number: { value: "" },
            logo: {},
          },
        },

        //Is or not sublimable prop
        isSublimable: !!pr.is_sublimable,
        //Is uniform
        isUniform: pr.category === "Jerseys",

        //Custom Configs
        threekitConfigId: pr.threekit_config_id,
        threekitSavedPreview: pr.threekit_saved_preview,
        threekitDecorations: pr.threekit_decorations,
      }));
      state.isStaticTemplate = snapsheetData.is_static_template || false;
      state.repId = snapsheetData.rep?.id;
      state.showPrices = !!snapsheetData.show_prices;
      state.status = snapsheetData.deleted_at
        ? CONSTANTS.PROJECT_STATUS.ARCHIVED
        : snapsheetData.status || "open";
      state.snapsheetCollections = snapsheetData.collections || [];
      state.snapsheetId = snapsheetData.id;
      state.teamName = snapsheetData.team_name;
      state.templateId = snapsheetData.template_id;
    },

    SET_PROJECT_LOCKER_CODE(state, lockerCode) {
      state.lockerCode = lockerCode;
    },

    SET_SNAPSHEET_SETTINGS(state, payload) {
      //Update Title, Rep or status
      const keys = Object.keys(payload);
      for (let index = 0; index < keys.length; index++) {
        const field = keys[index];
        state[field] = payload[field];
      }
    },

    SET_SNAPSHEET_SHOW_PRICES: (state, showPrices) => {
      state.showPrices = showPrices;
    },

    SET_SNAPSHEET_STATUS: (state, status) => {
      state.status = status;
    },

    SET_SNAPSHEETS_TEMPLATES: (state, templatesData) =>
      (state.snapsheetsTemplates = templatesData),

    SET_COLLECTIONS_CARDS_DATA: (state, collectionsCardsData) =>
      (state.collectionsCardsData = collectionsCardsData),

    SET_SNAPSHEET_COLLECTIONS: (state, collections) =>
      (state.snapsheetCollections = collections),

    setPages: (state, pages) => {
      state.pages = pages;
    },

    SET_PRODUCTS: (state, products) => {
      state.products = products;
    },

    // applyMainProductPrice: (state, value) => {
    //   rootState.project.temporalProduct.price = value
    // },

    // applyRelatedProductPrice: (state, { index, value }) => {
    //   rootState.project.temporalProduct.related[index].price = value
    // },

    // applyChangeOriginalLogo: (state, logoId) => {
    //   const updatedActiveProduct = { ...rootState.project.temporalProduct, logoId }
    //   Vue.set(state, 'temporalProduct', updatedActiveProduct)
    // },

    // applyScreenLogo: (state, screenLogoProperties) => {
    //   const updatedActiveProduct = { ...rootState.project.temporalProduct, screenLogo: screenLogoProperties }
    //   Vue.set(state, 'temporalProduct', updatedActiveProduct)
    // },

    // applyActiveLayoutId: (state, layoutId) => {
    //   rootState.project.temporalProduct.activeLayoutId = layoutId;
    // },

    ADD_PRODUCT: (state, { order, product }) => {
      console.log("ADD PR: ", product);
      Vue.set(state.products, order, product);
    },

    SWAP_PRODUCTS_ORDERS: (state, { order1, order2 }) => {
      Vue.set(state.products[order1 - 1], "order", order2);
      Vue.set(state.products[order2 - 1], "order", order1);
    },

    saveDecorationsData: (state, payload) => {
      state.products.forEach((product) => {
        if (payload.productsIds.includes(product.wrapperId)) {
          //update logo if it changed for the given wrapperid
          if (payload.logo) product.logo = payload.logo;
          //update selected layout only on current style
          if (payload.layoutProductId === product.wrapperId) {
            product.activeLayoutId = payload.activeLayout;
          }
        }
      });
    },

    setEditMode: (state, bool) => {
      state.isEditModeActive = bool; //boolean
    },

    setProductHasBeenEdited: (state, bool) => {
      state.productHasBeenEdited = bool; //boolean
    },

    setDecorationHasBeenEdited: (state, bool) => {
      state.decorationHasBeenEdited = bool; //boolean
    },

    setSnapsheetColor: (state, payload) => {
      state[payload.field] = payload.color.color.id;
    },

    toggleEditTitleActive: (state) => {
      state.editTitleActive = !state.editTitleActive;
    },

    saveSnapsheetTitle: (state, payload) => {
      state.title = payload.title;
    },

    SET_FEATURED_COLOR: (state, colorSelectedId) => {
      state.color_1 = colorSelectedId;
    },

    SET_COLOR: (state, { colorId, colorKey }) => {
      state[colorKey] = colorId;
    },

    EDIT_SNAPSHEET_LOGO: (state, logo) => {
      state.logos.splice(
        state.logos.findIndex((l) => l.id === logo.id),
        1,
        logo
      );
    },
  },
};

export default snapsheet;
